module.exports = __webpack_public_path__ + "media/clients/b-1-6159d8a3.png";